
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FloatingActionButton.css';

const FloatingActionButton = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/tasks/create');
    };

    return (
        <div className="floating-action-button-container">
            {/* Tooltip is now positioned absolutely and won't affect the button's layout */}
            <div className="tooltip-text">
                Create new task
            </div>
            
            <button
                className="floating-action-button"
                onClick={handleClick}
                aria-label="Create new task"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="28"
                    height="28"
                >
                    <path
                        fillRule="evenodd"
                        d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>
        </div>
    );
};

export default FloatingActionButton;